<template>
  <div>
    <p>
      <font color="#fe8087">温馨提示</font>
    </p>
    <p>
      <font color="#616797">1、须遵守上述约定时间，准时出席。</font>
    </p>
    <p>
      <font color="#616797"
        >2、若需取消，请在前一天晚上20点前在本系统上取消，取消成功后你会收到短信通知。</font
      >
    </p>
    <p>
      <font color="#616797"
        >3、如果迟到，咨询时间一般不会顺延；迟到超过30分钟咨询将会取消并被记为爽约。</font
      >
    </p>
    <p>
      <font color="#616797"
        >4、爽约不来的情况，可能会降低你以后预约的优先级。</font
      >
    </p>
  </div>
</template>

<script>
export default {
  methods: {  
  }
};
</script>
<style scoped>
p {
  line-height: 24px;
}
</style>
